"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyntheticsTriggerCITestRunResult = void 0;
/**
 * Information about a single test run.
 */
class SyntheticsTriggerCITestRunResult {
    constructor() { }
    /**
     * @ignore
     */
    static getAttributeTypeMap() {
        return SyntheticsTriggerCITestRunResult.attributeTypeMap;
    }
}
exports.SyntheticsTriggerCITestRunResult = SyntheticsTriggerCITestRunResult;
/**
 * @ignore
 */
SyntheticsTriggerCITestRunResult.attributeTypeMap = {
    device: {
        baseName: "device",
        type: "SyntheticsDeviceID",
    },
    location: {
        baseName: "location",
        type: "number",
        format: "int64",
    },
    publicId: {
        baseName: "public_id",
        type: "string",
    },
    resultId: {
        baseName: "result_id",
        type: "string",
    },
};
//# sourceMappingURL=SyntheticsTriggerCITestRunResult.js.map